import {useAxios} from "@/utils/useAxios";
import moment from "moment";

const api = {
    /*--------------------------마이페이지 홈----------------------------*/

    //마이페이지 메뉴 개별 목록 수
    async getMyPageTotalInfo(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getMypageTotInfo")
        await execute(params);
        return data.value.result;
    },

    /*--------------------------내정보관리----------------------------*/
    //사용자 정보 조회
    async getMyInformation(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getMember")
        await execute(params);
        return data.value.result;
    },

    //사용자 정보 수정
    async setMyInformation(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/setMember", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data.value.result
    },

    //청구인 정보 조회
    async getMyClaimInfo(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getMyClaimInfo")
        await execute(params);
        return data.value.result;
    },

    //비밀번호 검증
    async getPasswordVerify(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/verifyMyPassword", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data.value
    },

    //비밀번호 실패 횟수
    async getLoginFailCount() {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getLoginFailCount")
        await execute();
        return data.value.result;
    },

    /*--------------------------나의청구이력----------------------------*/
    //나의 청구이력 전체 조회
    async getMyClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getInsuClaims")
        await execute(params);
        return data.value.result
    },

    //나의 청구이력 상세조회
    async getDetailMyClaim2(params) {
        const {data, execute} = await useAxios("/cmm/api/v2/usr/getInsuClaim")
        await execute(params);
        return data.value.result
    },

    async getDetailMyClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getInsuClaim")
        await execute(params);
        return data.value.result
    },

    //추가서류 파일 다운로드
    async setClaimAttFileDownload(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getFntClaimAttFileDownload", {
            responseType: 'arraybuffer'
        }, {
            loading: true,
            exceptionThrow: true,
            onSuccess: (response) => {
                const blob = new Blob([response.data], {type: "application/zip"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");

                a.style.display = "none";
                a.href = url;
                a.download = moment().format('YYYYMMDDHHSS');
                document.body.appendChild(a);
                a.click();

                //메모리제거
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
        await execute(params);
    },

    //본인청구실패 재전송
    async setResendClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/setResendClaim", {}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data.value
    },

    //자녀청구실패 재전송
    async setResendChildClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/setResendChildClaim", {}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data.value
    },

    //청구실패 삭제
    async delClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/delClaim", {}, {
            exceptionThrow: true,
            loading: true
        })
        await execute(params);
        return data.value
    },

    /*--------------------------나의보험관리----------------------------*/

    //나의 보험 목록 조회
    async getMyInsu(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getMyInsu")
        await execute(params);
        return data.value.result
    },

    //보험사 목록 조회
    async getInsuCompanies(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getInsuCompanies")
        await execute(params);
        return data.value.result
    },

    //보험 등록
    async setMyInsu(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/genMyInsu", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data.value
    },

    //보험 삭제
    async delMyInsu(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/delMyInsu", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data.value
    },
    /*--------------------------나의자녀관리----------------------------*/
    //자식 목록 조회
    async getMyChild(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getMemberChild", {}, {
            loading: true
        })
        await execute(params);
        return data.value.result
    },
    //자식 삭제
    async delMyChild(params) {
        const {execute} = await useAxios("/cmm/api/v1/usr/delMemberChild", {}, {
            exceptionThrow: true
        })
        await execute(params);
    },
    //자식 등록
    async setMyChild(params) {
        const {execute} = await useAxios("/cmm/api/v1/usr/genMemberChild", {}, {
            exceptionThrow: true
        })
        await execute(params);
    },

    /*--------------------------나의위임관리----------------------------*/
    //위임 목록 조회
    async getMyDelegate(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getDeputyClaimTargetMember")
        await execute(params);
        return data.value.result
    },
    //위임 삭제
    async delMyDelegate(params) {
        const {execute} = await useAxios("/cmm/api/v1/usr/delDeputyClaimTargetMember", {}, {
            exceptionThrow: true
        })
        await execute(params);
    },
    //위임 등록
    async genMyDelegate(params) {
        const {execute} = await useAxios("/cmm/api/v1/usr/genDeputyClaimTargetMember", {}, {
            exceptionThrow: true
        })
        await execute(params);
    },
    //위임 수정
    async setMyDelegate(params) {
        const {execute} = await useAxios("/cmm/api/v1/usr/setDeputyClaimTargetMember", {}, {
            exceptionThrow: true
        })
        await execute(params);
    },
    /*--------------------------약관동의관리----------------------------*/
    //약관동의 목록 조회
    async getMyAgree(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getTermsAgreeNewList")
        await execute(params);
        return data.value.result
    },

    async getTermsAgreeDtlNew(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/getTermsAgreeDtlNew")
        await execute(params);
        return data.value.result
    },

    //약관동의 철회
    async delTermsAgree() {
        const {execute} = await useAxios("/cmm/api/v1/base/delTermsAgree", {}, {
            exceptionThrow: true
        })
        await execute();
    },

    /*--------------------------환경설정----------------------------*/

    //공인인증서와 아이디 연결
    async setCertOfficialLogin(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/member/setCertOfficialLogin", {
            headers: {'Content-Type': 'multipart/form-data'},
        }, {
            exceptionThrow: true
        })
        await execute(params);
        return data.value
    },

    //인증수단 관리 -> 내가 등록한 로그인 인증수단 목록 조회
    async getLoginMethod() {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getLoginMethod")
        await execute({});
        return data.value.result
    },

    //회원탈퇴
    async delMember(params) {
        const {execute} = await useAxios("/cmm/api/v1/member/delMember", {}, {
            exceptionThrow: true,
            loading: true,
        })
        await execute(params);
    },

    //사용자정보상세조회
    async getMemberInfo(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/member/getMemberInfo", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data.value.result;
    },
}

export default api;